/**
 * Builds the summary text string shown beneath the list.
 * Returns a bullet-separated string when a prefix label is present
 * (e.g. "Circuit • 36 test circuits • 179.9 miles"), or a
 * comma-separated string for the plain network view
 * (e.g. "36 test circuits, 179.9 miles").
 */
export function buildSummaryText(
  prefix: string | null,
  count: string,
  unitLabel: string,
  dist: string
): string {
  if (prefix != null) {
    return [prefix, `${count} ${unitLabel}`, dist].filter(Boolean).join(' • ');
  }
  return `${count} ${unitLabel}, ${dist}`;
}
